import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

interface LinkReadyDialogProps {
  /** The link waiting to go out; null keeps the dialog closed. */
  url: string | null;
  /** Share on a phone, copy on a desktop — the same choice the first try made. */
  viaShareSheet: boolean;
  onSend: () => Promise<void>;
  onDismiss: () => void;
}

/**
 * "Your link is ready": a link the browser wouldn't share or copy because the
 * tap that asked for it had expired while the link was made. One button, a
 * fresh tap, sends it. The link also sits in a field, selectable by hand on a
 * browser that can do neither. See [[add-contributor-sheet.spec]].
 */
export function LinkReadyDialog({
  url,
  viaShareSheet,
  onSend,
  onDismiss,
}: LinkReadyDialogProps) {
  return (
    <Dialog
      open={url !== null}
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Your link is ready</DialogTitle>
          <DialogDescription>Works for 7 days.</DialogDescription>
        </DialogHeader>
        <Input
          readOnly
          value={url ?? ""}
          aria-label="Invite link"
          onFocus={(event) => event.currentTarget.select()}
        />
        <DialogFooter className="p-0 pt-2">
          <Button variant="outline" onClick={onDismiss}>
            Cancel
          </Button>
          <Button onClick={() => void onSend()}>
            {viaShareSheet ? "Share link" : "Copy link"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
